<ng-container [formGroup]="staffDetailForm">
    <div class="card-body">
      <h2>Staff Detail</h2>
      <div class="form-row mt-2">
        <div class="form-group col-8">
          <label for="name" class="custom_label">Phone Number *</label>
          <input matInput phoneMask type="text" id="name" formControlName="phone_number" class="form-control" placeholder="Phone Number" name="name" required>
          <app-validation-error [formGroup]="staffDetailForm"   [controlName]="'phone_number'"></app-validation-error>
        </div>
        <div class="form-group col-4">
          <label for="extension" class="custom_label">Extension</label>
          <input type="text" id="extension" formControlName="extension" class="form-control" placeholder="Ext." name="extension" maxlength="10">
        </div>
        <div class="form-group col-12 py-2">
            <label for="group" class="custom_label">Staff Department *</label>
            <ng-select
              [items]="activeDepartments"
              id="group"
              placeholder="Select Department"
              [closeOnSelect]="true"
              formControlName="department"
              bindLabel="name"
            >
            </ng-select>
            <app-validation-error [formGroup]="staffDetailForm"  [controlName]="'department'"></app-validation-error>
          </div>
          <div class="form-group col-12 py-2">
            <label for="group" class="custom_label">Roles *</label>
            <ng-select
              [items]="rolesList"
              id="group"
              [multiple]="true"
              placeholder="Select Roles"
              [closeOnSelect]="true"
              formControlName="roles"
              bindLabel="name"
            >
            </ng-select>
            <app-validation-error [formGroup]="staffDetailForm" [controlName]="'roles'"></app-validation-error>
          </div>
      </div>


      <div class="form-row">
        <div class="form-group col-12">
          <label for="supervisors_id" class="custom_label">Supervisors </label>
          <ng-select
            id="supervisors_id"
            [items]="staffs"
            placeholder="Select Supervisors"
            [closeOnSelect]="true"
            [multiple]="true"
            formControlName="supervisors"
            bindLabel="{{coreService.ngSelectBindStaffLabel}}"
          >
          </ng-select>
          <app-validation-error [formGroup]="staffDetailForm" [controlName]="'supervisors'"></app-validation-error>
        </div>
      </div>

      <div class="form-group py-2">
        <label class="custom_label">Start date *</label>
      <mat-form-field appearance="fill" class="input_datepicker" style="margin-bottom: -15px;">
<!--        <mat-label>Select Date</mat-label>-->
        <input matInput [matDatepicker]="picker" placeholder="Select Date" formControlName="start_date" >
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <app-validation-error [formGroup]="staffDetailForm" [controlName]="'start_date'"></app-validation-error>
      </div>


      <div class="form-group mt-2">
        <label class="custom_label">Birthday *</label>
      <mat-form-field appearance="fill" class="input_datepicker" style="margin-bottom: -15px;">
<!--        <mat-label>Select Date</mat-label>-->
        <input matInput [matDatepicker]="birthdayPicker"  placeholder="Select Date" formControlName="birthday" >
        <mat-datepicker-toggle matSuffix [for]="birthdayPicker"></mat-datepicker-toggle>
        <mat-datepicker #birthdayPicker></mat-datepicker>
      </mat-form-field>
      <app-validation-error [formGroup]="staffDetailForm" [controlName]="'birthday'"></app-validation-error>
      </div>

      <div class="form-row mt-2">
        <div class="form-group col-12">
            <label for="group" class="custom_label">Language *</label>
            <ng-select
            [items]="languageTimeZone?.languages"
              id="group"
              placeholder="Select Language"
              [closeOnSelect]="true"
              formControlName="language"
              bindLabel="name"
            >
            </ng-select>
            <app-validation-error [formGroup]="staffDetailForm" [controlName]="'language'"></app-validation-error>
          </div>

          <div class="form-group col-12">
            <label for="group" class="custom_label">Timezone *</label>
            <ng-select
            [items]="languageTimeZone?.timezone"
              id="group"
              placeholder="Select Timezone"
              [closeOnSelect]="true"
              formControlName="time_zone"
              bindLabel="zone"
            >
            </ng-select>
            <app-validation-error [formGroup]="staffDetailForm"  [controlName]="'time_zone'"></app-validation-error>
          </div>
        </div>
    </div>
  </ng-container>
